import React from 'react'

import FormbuilderFieldWrapper from './formbuilderFieldWrapper';
import AddressAutocomplete from './addressComponents/addressAutocomplete';
import AddressManualInputs from './addressComponents/addressManualInputs';

import './index.css';

class FormbuilderAddress extends React.Component {
    state = {
        showAdditionalComponents: false
    }

    onLinkCLick = () => {
        this.setState((prev) => {
            return {
                showAdditionalComponents: !prev.showAdditionalComponents
            }
        });
    }

    render() {
        const { value, onChange, identifier, label, validation, error, onBlur, inputSub, popup, initialValidation } = this.props;
        const { showAdditionalComponents } = this.state;
        const errorMessage = value ? "Please select a full address" : null;

        return (
            <FormbuilderFieldWrapper label={label}
                identifier={identifier}
                error={error}
                errorMessage={errorMessage}
                onBlur={onBlur}
                inputSub={inputSub}
                popup={popup}
                value={value}
                validation={showAdditionalComponents ? undefined : validation}
                initialValidation={initialValidation}>
                {
                    showAdditionalComponents === false &&
                    <div>
                        <AddressAutocomplete id='formbuilder-address'
                            onChange={onChange}
                            value={value} />
                        {/*eslint-disable-next-line*/}
                        <a className="formbuilder-address-link" onClick={this.onLinkCLick}>Can't find your address?</a>
                    </div>
                }
                {
                    showAdditionalComponents === true &&
                    <div>
                        <AddressManualInputs value={value}
                            validation={{ required: validation && validation.required }}
                            onChange={onChange} />
                        {/*eslint-disable-next-line*/}
                        <a className="formbuilder-address-link" onClick={this.onLinkCLick}>Back to automatic lookup</a>
                    </div>
                }
            </FormbuilderFieldWrapper>
        );
    }
}

export default FormbuilderAddress;